import React, { useEffect, useState, useRef } from 'react';
import FpsStockDetailsSch from './FPS_Stock_details_sch';
import { exportToExcelFpsStock } from './exportToExcelFpsStock';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const MonthC = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

const Stock_data = async (month, year, fps_id) => {
    const response = await fetch(`${process.env.REACT_APP_URL_FPS}/fps/getfpsStockregister?fpsId=` + fps_id + '&month=' + month + '&year=' + year, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    });
    if (!response.ok) {
        throw new Error('Failed to fetch data');
    }
    return response.json();
};

const FPS_Stock_details = ({ month, year, fps_id, heading }) => {
    const [reportData, setReportData] = useState([]);
    const [fpsStatus, setFpsStatus] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [tabHeading] = useState(heading);
    const [renderContentt, setRenderContentt] = useState(null);
    const detailsRRef = useRef(null); // Use ref to scroll to this div
    const handleClick = (month, year, fps_id, comm_id) => {
        setRenderContentt(null);
        setTimeout(() => {

            setRenderContentt(
                <FpsStockDetailsSch
                    month={month}
                    year={year}
                    fps_id={fps_id}
                    comm_id={comm_id}
                />
            );

        }, 10);
    };

    useEffect(() => {
        const getData = async () => {
            try {
                const response_data = await Stock_data(month, year, fps_id);

                if (response_data && Array.isArray(response_data) && response_data.length > 0) {
                    setReportData(response_data);

                    try {
                        const fps_req = await fetch(`${process.env.REACT_APP_URL_FPS}/Common/getFpsStatus?fpsId=${fps_id}&month=${month}&year=${year}`, {
                            method: 'POST'
                        });
                        if (fps_req.ok) {
                            const fps_res = await fps_req.text();
                            try {
                                const json = JSON.parse(fps_res);
                                if (json && json.fps_status) setFpsStatus(json.fps_status);
                                else if (Array.isArray(json) && json.length > 0 && json[0].fps_status) setFpsStatus(json[0].fps_status);
                                else if (json && json.status) setFpsStatus(json.status);
                                else if (Array.isArray(json) && json.length > 0 && json[0].status) setFpsStatus(json[0].status);
                                else if (json && json.STATUS) setFpsStatus(json.STATUS);
                                else if (Array.isArray(json) && json.length > 0 && json[0].STATUS) setFpsStatus(json[0].STATUS);
                                else setFpsStatus(JSON.stringify(json).replace(/["{}]/g, ''));
                            } catch (e) {
                                setFpsStatus(fps_res);
                            }
                        }
                    } catch (e) {
                        console.error("Error fetching fps status", e);
                    }

                } else {
                    setReportData([]);  // Ensure reportData is an array
                }
            } catch (error) {
                setError(error);
            } finally {
                setLoading(false);
            }
        };

        getData();
    }, [month, year, fps_id]);


    useEffect(() => {
        if (!loading && !error && reportData.length > 0 && reportData.current) {
            reportData.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [loading, error, reportData]);


    if (loading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'start' }}>

                <Box sx={{ display: 'flex' }}>
                    <CircularProgress />
                </Box>
            </div>
        );
    }


    if (error) {
        return <div className="mainhead" align="center">Internal error</div>;
    }

    if (reportData.length == 0) {
        return <div className="mainhead" align="center">No data found</div>;
    }

    const showType = reportData.some(item => item.type !== null && item.type !== undefined);

    return (
        <>
            <table align="center" width="90%" border={1}>
                <thead>
                    <tr className="tableheader">
                        <th colSpan={showType ? 14 : 13}>
                            {`${tabHeading} for FPS Id : ${fps_id} `}
                            {fpsStatus && <span>( <font style={{ color: '#ff8000' }}> FPS Status</font> : {fpsStatus} ) </span>}
                            {`( District : ${reportData[0].distNameEn} ) (Office:${reportData[0].afso_name_en}) ${MonthC[parseInt(month) - 1]} - ${year}`}
                        </th>
                    </tr>

                    <tr className="tableheader">
                        <th rowSpan={3}>Sl.No</th>
                        <th rowSpan={3}>Commodity</th>
                        {showType && <th rowSpan={3}>Type</th>}
                        <th rowSpan={3}>Units</th>
                        <th rowSpan={3}>Alloted Qty</th>
                        <th rowSpan={3}> OB Qty<br /><span className="styleDF">(A)</span></th>
                        <th colSpan={6}> Received Qty</th>
                        <th rowSpan={3}>Issued Qty<br /> <span className="styleDF">(E)</span></th>
                        <th rowSpan={3}> CB Qty<br /><span className="styleDF">(A+B+C+D-E)</span></th>

                    </tr>

                    <tr className="tableheader">
                        <th colSpan={4}> Regular<br /><span className="styleDF"></span></th>
                        <th rowSpan={3}>Extra<br /> <span className="styleDF">(C)</span> </th>
                        <th rowSpan={3}> Moved<br /> <span className="styleDF">(D)</span></th>
                    </tr>

                    <tr className="tableheader">
                        <th>Previous Month</th>
                        <th>Current Month</th>
                        <th>Future Month</th>
                        <th> Total<br /> <span className="styleDF">(B)</span></th>

                    </tr>
                </thead>

                <tbody>
                    {
                        reportData.map((item, index) => (
                            <tr key={item.dist_code}>
                                <td style={{ textAlign: 'center' }}>{index + 1}</td>

                                <td style={{ textAlign: 'left' }}>
                                    <a href="#!" style={{ cursor: 'pointer', color: 'blue' }}
                                        onClick={(e) => { e.preventDefault(); handleClick(month, year, fps_id, item.commId); }}  >
                                        {item.commNameEn}</a></td>
                                {showType && <td style={{ textAlign: 'center' }}>{item.type}</td>}
                                <td style={{ textAlign: 'left' }}>{item.commMeasureUnit}</td>
                                <td style={{ textAlign: 'right' }}>{item.allottedQty}</td>
                                <td style={{ textAlign: 'right' }}>{item.ob}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.prevMonth).toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.curntMonth).toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{Number(item.futrMonth).toFixed(3)}</td>
                                <td style={{ textAlign: 'right' }}>{item.receivedQty}</td>
                                <td style={{ textAlign: 'right' }}>{item.extraRo}</td>
                                <td style={{ textAlign: 'right' }}>{item.sixaCase}</td>
                                <td style={{ textAlign: 'right' }}>{item.issuedQty}</td>
                                <td style={{ textAlign: 'right' }}>{item.cb}</td>

                            </tr>
                        ))
                    }
                    <tr className="tableheader">
                        <td colSpan={showType ? 14 : 13} style={{ textAlign: 'right' }}>
                            Data Time:
                            <font style={{ color: 'red' }}>
                                {reportData[0]?.refreshTime?.substring(0, 16)}
                            </font>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div style={{ textAlign: "center", marginBottom: "30px", marginTop: "15px" }}>
                <button
                    onClick={() => exportToExcelFpsStock({ month, year, fps_id, reportData, fpsStatus, tabHeading, MonthC })}
                    style={{
                        padding: "6px 15px", borderRadius: "10px", border: "none",
                        backgroundColor: "black", color: "white", cursor: "pointer", marginRight: "10px"
                    }}
                >
                    Data to Export
                </button>
            </div>
            <br />
            <br />
            <div id="detailsERR" ref={detailsRRef}>{renderContentt}</div>
        </>
    );
};

export default FPS_Stock_details;
